import { render, staticRenderFns } from "./add-route.vue?vue&type=template&id=1ca56a28&scoped=true&"
import script from "./add-route.vue?vue&type=script&lang=js&"
export * from "./add-route.vue?vue&type=script&lang=js&"
import style0 from "./add-route.vue?vue&type=style&index=0&id=1ca56a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca56a28",
  null
  
)

export default component.exports